<template>
  <div>
    <div class="title-div">燃气我的报修</div>
    <!--条件选择器-->
    <div class="selectBox">
      <!--<div class="select-div">
        <el-select v-model="value1" placeholder="请选择" @change="getRepairList()">
          <el-option
            v-for="item in option1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>-->
      <div class="select-div">
        <el-select v-model="value2" placeholder="请选择" @change="getRepairList()">
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="select-div">
        <el-select v-model="value3" placeholder="请选择" @change="getRepairList()">
          <el-option
            v-for="item in options3"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <!--列表块-->
    <div class="list" v-loading="loading">
      <div v-for="(item, index) in repairList" :key="index" class="card" @click="toPCRepairDetail(item)">
        <!--第一行-->
        <div class="row-div top-div">
          <div class="top-center-cell">
            <img src="../../../assets/pc/pcRepair/repair.png">
            <span class="repair-span">维修</span>
          </div>
          <div class="status-div">
            <img src="../../../assets/pc/pcRepair/end.png" v-if="item.repairState == '已完成'">
            <img src="../../../assets/pc/pcRepair/repairing.png" v-if="item.repairState == '处理中'">
            <img src="../../../assets/pc/pcRepair/unfinished.png" v-if="item.repairState == '未完成'">
            <span class="status-span"
                  :class="item.repairState == '未完成' ? 'orange' : item.repairState == '已完成' ? 'green' : 'blue'">
              {{item.repairState}}
            </span>
          </div>
        </div>
        <!--第二行-->
        <div class="bottom-div">
          {{item.repairTypeChina}}
        </div>
        <!--分割线-->
        <div>
          <el-divider class="divider-style"></el-divider>
        </div>
        <!--服务编号-->
        <div class="cardFoot">
          <div class="left-cell">
            服务编号：{{item.serviceNumber}}
          </div>
          <div class="right-cell">
            {{item.createDate}}
          </div>
        </div>
      </div>
    </div>
    <el-empty description="暂无数据" v-if="isEmpty"></el-empty>
    <!--<div align="center">
      <el-button type="primary" class="submit-button">提交</el-button>
    </div>-->
  </div>
</template>

<script>
  import { query } from '../../../api/repair'
  import { getUserGasList } from '../../../api/accountNumberManagement'

  export default {
    name: 'PCMyRepair',
    data () {
      return {
        option1: [{
          value: '全部',
          label: '全部'
        }], // 户号列表
        options2: [{
          value: 'all',
          label: '全部'
        }, {
          value: 'BG_GAS_PIPE',
          label: '管道阀门报修'
        }, {
          value: 'BG_GAS_METER',
          label: '燃气表报修'
        }, {
          value: 'BG_GAS_STOVE',
          label: '燃气具报修'
        }, {
          value: 'BG_GAS_MODIFY',
          label: '拆改迁'
        }, {
          value: 'BG_GAS_OTHER',
          label: '其他报修'
        }], // 报修类型列表
        options3: [{
          value: '1',
          label: '最近1个月'
        }, {
          value: '3',
          label: '最近3个月'
        }, {
          value: '12',
          label: '最近1年'
        }], // 时间列表
        value1: '全部', // 筛选条件-户号
        value2: 'all', // 筛选条件-报修类型
        value3: '1', // 筛选条件-报修类型
        loading: false, // 是否显示加载提示
        repairList: [], // 报修列表
        isEmpty: false, // 是否显示空状态
        gasAccountInfo: {} // 户号信息
      }
    },
    mounted () {
      if (this.$route.params.gasAccountInfo) {
        this.gasAccountInfo = this.$route.params.gasAccountInfo
        window.localStorage.gasAccountInfo = JSON.stringify(this.$route.params.gasAccountInfo)
      } else {
        this.gasAccountInfo = JSON.parse(window.localStorage.gasAccountInfo)
      }
      // this.getNumberList()
      this.getRepairList()
    },
    methods: {
      // 跳转到报修详情页面
      toPCRepairDetail (item) {
        this.$router.push({
          name: 'PCRepairDetail',
          params: { detail: item }
        })
      },

      // 获取用户绑定的燃气号列表
      getNumberList () {
        let that = this
        const params = {
          userId: JSON.parse(window.localStorage.userInfo).id
        }
        getUserGasList(params).then(res => {
          if (res.data.success) {
            that.option1 = [{
              label: '全部',
              value: '全部'
            }]
            for (let i = 0; i < res.data.rows.length; i++) {
              that.option1.push({
                label: res.data.rows[i].label + '：' + res.data.rows[i].userCode,
                value: res.data.rows[i].userCode
              })
            }
          } else {
            this.$message.error(res.data.message ? res.data.message : '获取用户编号异常')
          }
        }).catch(() => {
          this.$message.error('获取用户编号异常')
        })
      },

      // 获取报修列表
      getRepairList () {
        let that = this
        that.loading = true
        const params = {
          appContactId: JSON.parse(window.localStorage.userInfo).appContactId ? JSON.parse(window.localStorage.userInfo).appContactId : '',
          userId: JSON.parse(window.localStorage.userInfo).id,
          // gasUserNumber: (that.value1 === '全部') ? 'all' : that.value1,
          gasUserNumber: that.gasAccountInfo.gasAccount,
          type: that.value2,
          time: that.value3,
          userNote: 'Bjtong',
          dataSource: 'Bjtong'
        }
        query(params).then(res => {
          if (res.data.success) {
            that.repairList = []
            that.isEmpty = false
            if (res.data.rows.length > 0) {
              for (let i = 0; i < res.data.rows.length; i++) {
                that.repairList.push(res.data.rows[i])
              }
            } else {
              that.isEmpty = true
            }
            that.loading = false
          } else {
            that.loading = false
            that.$message.error(res.data.message)
            that.repairList = []
            that.isEmpty = true
          }
        }).catch(() => {
          that.loading = false
          that.$message.error('查询失败')
        })
      }
    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .selectBox {
    padding: 0 14%;
    display: flex;
    margin: 32px 0;
  }

  .list {
    padding: 0 14%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .row-div {
    display: flex;
  }

  .top-div {
    padding: 14px 6% 11px 5%;
    align-items: center;
  }

  .card {
    width: 31%;
    box-shadow: 0px 2px 4px 4px rgba(215, 215, 215, 0.5);
    border-radius: 2px;
    border: 1px solid #DCDFE6;
    margin-bottom: 30px;
    margin-right: 2%;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }

  .submit-button {
    width: 400px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
    margin-bottom: 80px;
    margin-top: 99px;
  }

  .top-center-cell {
    width: 50%;
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
    display: flex;
  }

  .bottom-div {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #000000;
    line-height: 21px;
    padding-left: 5%;
  }

  .cardFoot {
    display: flex;
    padding-bottom: 33px;
  }

  /deep/ .el-select .el-input__inner:focus {
    border-color: #BD1A2D;
  }

  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #BD1A2D;
  }

  .el-select-dropdown__item.selected {
    color: #BD1A2D;
  }

  .select-div {
    margin-right: 4%;
  }

  .status-div {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 50%;
  }

  .orange {
    color: #FF6B38;
  }

  .green {
    color: #00AE8D;
  }

  .blue {
    color: #004FDF;
  }

  .repair-span {
    margin-left: 10%;
  }

  .status-span {
    margin-left: 5%;
  }

  .divider-style {
    margin: 12px 0 5px 0;
  }

  .left-cell {
    width: 65%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #62667A;
    padding-left: 5%;
  }

  .right-cell {
    width: 35%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #62667A;
    text-align: right;
    padding-right: 5%;
  }
</style>
